<template>
  <div class="fastNews">
    <h2 class="normal">小鸡快讯</h2>
    <div class="normal">
      <div class="inputBox">
        <textarea placeholder="标题" v-model="tag_name" rows="5" cols="60"></textarea>
      </div>
    </div>
    <div class="normal">
      <div class="inputBox">
        <textarea placeholder="正文" v-model="words" rows="10" cols="80"></textarea>
      </div>
    </div>

    <div class="normal">
      <input type="file" @change="chooseImage">
    </div>
    <div class="imageBox">
      <div v-for="(url,index) in images" :key="index" class="imageItem">
        <img :src="url.replace('_mini.jpg', '')" preview="8">
        <button @click="delImage(index)">删除</button>
      </div>
    </div>
    
    <div class="normal">
        <el-button type="primary" @click="upToDb">上传</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tag_id: '',
        tag_name:'', // 标题
        words: '', // 文字内容
        images: [],
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {

      init() {
        let that = this
        let obj = that.$route.params
        if (obj.id) {
          that.$axios.get(that.$url_prefix + 'queryOneById', {
            params: {
              id: obj.id,
              db: 'WpTagModel'
            }
          }).then(function (res) {
            if (res.data.success) {
                that.tag_id = res.data.data.id;
                that.tag_name = res.data.data.tag_name;
                that.words = res.data.data.words;
                if (res.data.data.images) {
                  that.images = JSON.parse(res.data.data.images);
                  that.$previewRefresh();
                } else {
                  that.images = [];
                }
            } else {
                that.$message.error('数据不存在');
            }
          }).catch(function (res) {
            console.log('err', res)
            alert('查询失败，请检查网络')
          })
        }
      },

      upToDb() {
        let that = this
        if (!that.tag_name || !that.words) {
            return;
        }
        let obj = {
            words: that.words,
            tag_name: that.tag_name,
        }

        if (that.tag_id) {
          obj.id = that.tag_id;
        } else {
          obj.type = '小鸡快讯'
        }
        if (that.images.length > 0) {
          obj.images = JSON.stringify(that.images);
        } else {
          obj.images = '';
        }

        let param = {
          'db': 'WpTagModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('发送返回', res)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('上传失败', res)
        })

      },

      //选择图片
      chooseImage(event) {
        let that = this;
        let option = {
          file: event.target.files[0],
          head_name: 'news',
        };
        that.$uploadImage(option).then(function (res) {
          console.log('upload back', res);
          if (!res) {
            console.log('upload fail')
            return;
          }
          that.images.push(res);
          that.$previewRefresh();
        }).catch(function (res) {
          console.log('upload fail', res);
        })
      },

      delImage(index) {
        this.images.splice(0,1);
      }

    }
  }

</script>

<style scoped>
    .fastNews {
        text-align: center;
        overflow: hidden;
    }
    .inputBox {
        display: inline-block;
    }
    textarea {
      font-size: 17px;
    }

    .imageBox {
      margin: 20px auto;
      display: flex;
      flex-wrap: wrap;
    }

    .imageBox .imageItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px;
    }
    img {
      height: 100px;
      width: 100px;
      vertical-align: bottom;
    }
</style>



// WEBPACK FOOTER //
// src/page/FastNews.vue